"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAPI = void 0;
const api_1 = require("../api");
const Service = 'platform';
class PlatformAPI extends api_1.AbstractUtxoAPI {
    chain;
    constructor(client, chain) {
        super(client, `/ext/bc/${chain.id}`, Service);
        this.chain = chain;
    }
    async getBlock(blockID, encoding) {
        const response = await this.call('getBlock', [{ blockID, encoding }]);
        return response.result;
    }
    async getBlockByHeight(height, encoding) {
        const response = await this.call('getBlockByHeight', [{ height, encoding }]);
        return response.result;
    }
    /**
     * @deprecated
     */
    async getBlockchains() {
        const response = await this.call('getBlockchains');
        return response.result;
    }
    async getBlockchainStatus(blockchainID) {
        const response = await this.call('getBlockchainStatus', [{ blockchainID }]);
        return response.result;
    }
    async getCurrentSupply(supernetID) {
        const response = await this.call('getCurrentSupply', [{ supernetID }]);
        return response.result;
    }
    async getRewardPoolSupply(supernetID) {
        const response = await this.call('getRewardPoolSupply', [{ supernetID }]);
        return response.result;
    }
    async getCurrentValidators(supernetID, nodeIDs) {
        const response = await this.call('getCurrentValidators', [{ supernetID, nodeIDs }]);
        return response.result;
    }
    async getHeight() {
        const response = await this.call('getHeight');
        return response.result;
    }
    async getMinStake(supernetID) {
        const response = await this.call('getMinStake', [{ supernetID }]);
        return response.result;
    }
    async getStakingAssetID(supernetID) {
        const response = await this.call('getStakingAssetID', [{ supernetID }]);
        return response.result;
    }
    /**
     * @deprecated
     * // TODO must be replace with getSupernet
     */
    async getSupernets(ids) {
        const response = await this.call('getSupernets', [{ ids }]);
        return response.result;
    }
    async getTimestamp() {
        const response = await this.call('getTimestamp');
        return response.result;
    }
    async getTotalStake(supernetID) {
        const response = await this.call('getTotalStake', [{ supernetID }]);
        return response.result;
    }
    async getTxStatus(txID) {
        const response = await this.call('getTxStatus', [{ txID }]);
        return response.result;
    }
    async getValidatorsAt(height, supernetID) {
        const response = await this.call('getValidatorsAt', [{ height, supernetID }]);
        return response.result;
    }
    async sampleValidators(size, supernetID) {
        const response = await this.call('sampleValidators', [{ size, supernetID }]);
        return response.result;
    }
    async validatedBy(blockchainID) {
        const response = await this.call('validatedBy', [{ blockchainID }]);
        return response.result;
    }
    async validates(supernetID) {
        const response = await this.call('validates', [{ supernetID }]);
        return response.result;
    }
}
exports.PlatformAPI = PlatformAPI;
